import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-redirect-document',
  templateUrl: './redirect-document.component.html',
  styleUrls: ['./redirect-document.component.scss']
})
export class RedirectDocumentComponent implements OnInit {

    id: string = "0";

    constructor(private route: ActivatedRoute,
        private router: Router, private common: CommonService) {

        this.route.params.subscribe(val => {

            let map: any = this.route.paramMap;
            this.id = map.destination._value.id;

            this.router.navigate(['/home/document/' + this.id]);
        });

    }

    ngOnInit(): void {

  }

}
